import React, { memo, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  getChangeShowsortModeAction,
  getChangeShowsLayoutModeAction,
  getChangeShowsTemporalIntervalAction,
  getChangeShowsSortModeAction,
} from "../../store/actionCreators";
import {
  ShowsDtpFilterBarDivider,
  ShowsDtpFilterBarLeftWrapper,
  ShowsDtpFilterBarRightWrapper,
  ShowsDtpFilterBarWrapper,
  ShowsDtpFilterDropdownTitle,
  ShowsDtpFilterDropdownWrapper,
} from "./style";
import {
  showsAllEventsSortModes,
  showsFilterDateIntervals,
} from "../../local-data";
import { Dropdown } from "antd";
import {
  LAYOUT_MODE_CARD,
  LAYOUT_MODE_LIST,
} from "../../../../common/constants";
import classNames from "classnames";
import { ReactComponent as CardLayoutIcon } from "@/assets/img/icons/icon-layout-card.svg";
import { ReactComponent as ListLayoutIcon } from "@/assets/img/icons/icon-layout-list.svg";
import KTHomeDesktopFilterButton from "../../../home/c-pages/all-events/c-components/home-desktop-filter-bar/c-components/home-desktop-filter-button";
import KTSwitchCityDtpDropdown from "../../../../components/dropdown/switch-city-dtp-dropdown";
import { getGlobalDateString } from "../../../../utils/tool-time-intervcal";
import KTSwitchCustomTimeIntervalDropdown from "../../../../components/dropdown/switch-custom-time-interval-dropdown";

const KTShowsDtpFiterBar = memo(() => {
  const dispatch = useDispatch();

  const [customTimeIntervalOpen, setCustomTimeIntervalOpen] = useState(false);

  const { sortMode, layoutMode, intervalType, startdt, enddt, city } =
    useSelector(
      (state) => ({
        sortMode: state.getIn(["shows", "sortMode"]),
        layoutMode: state.getIn(["shows", "layoutMode"]),
        categories: state.getIn(["shows", "categories"]),
        intervalType: state.getIn(["shows", "intervalType"]),
        startdt: state.getIn(["shows", "startdt"]),
        enddt: state.getIn(["shows", "enddt"]),
        city: state.getIn(["global", "city"]),
      }),
      shallowEqual
    );

  let cityMessage = "Any Location";

  if (typeof city === "object" && Object.keys(city).length > 0) {
    const name = city.name ?? city.city ?? "";
    const state = city.state ?? "";
    if (name.length === 0 || state.length === 0) {
      cityMessage = `${name}${city.state}`;
    } else {
      cityMessage = `${name}, ${city.state}`;
    }
  }

  const onclickChangeLayoutMode = (mode) => {
    dispatch(getChangeShowsLayoutModeAction(mode));
  };

  function dropdownRender(menu) {
    return (
      <ShowsDtpFilterDropdownWrapper>
        {React.cloneElement(menu, {
          style: { boxShadow: "none" },
        })}
      </ShowsDtpFilterDropdownWrapper>
    );
  }

  // sort
  const sortItems = showsAllEventsSortModes
    .map((ele, index) => {
      const resultArr = [
        {
          label: (
            <ShowsDtpFilterDropdownTitle>
              {ele.title}
            </ShowsDtpFilterDropdownTitle>
          ),
          key: index,
        },
      ];

      resultArr.push({
        type: "divider",
        style: { margin: "0 0" },
      });

      return resultArr;
    })
    .flat();

  const onSortModeClick = ({ key }) => {
    const sortMode = showsAllEventsSortModes[key];
    dispatch(getChangeShowsSortModeAction(sortMode));
  };

  // date range

  const dateMessage = getGlobalDateString(
    showsFilterDateIntervals,
    intervalType,
    startdt,
    enddt
  );

  const dateRangeItems = showsFilterDateIntervals
    .map((ele, index) => {
      const resultArr = [
        {
          label: (
            <ShowsDtpFilterDropdownTitle>
              {ele.title}
            </ShowsDtpFilterDropdownTitle>
          ),
          key: index,
        },
      ];

      resultArr.push({
        type: "divider",
        style: { margin: "0 0" },
      });

      return resultArr;
    })
    .flat();

  const onDateRangeClick = ({ key }) => {
    const dateRange = showsFilterDateIntervals[key];
    dispatch(getChangeShowsTemporalIntervalAction(dateRange.value));

    if (key === "6") {
      setCustomTimeIntervalOpen(true);
    }
  };

  return (
    <ShowsDtpFilterBarWrapper>
      <ShowsDtpFilterBarLeftWrapper>
        <Dropdown
          autoAdjustOverflow={false}
          menu={{ items: sortItems, onClick: onSortModeClick }}
          trigger={["click"]}
          dropdownRender={dropdownRender}
        >
          <KTHomeDesktopFilterButton
            title={sortMode.title}
            styled={1}
            onClick={(e) => e.preventDefault()}
          />
        </Dropdown>

        <ShowsDtpFilterBarDivider />

        <KTSwitchCityDtpDropdown>
          <KTHomeDesktopFilterButton
            title={cityMessage}
            onClick={(e) => e.preventDefault()}
          />
        </KTSwitchCityDtpDropdown>

        <KTSwitchCustomTimeIntervalDropdown
          open={customTimeIntervalOpen}
          onCancelClick={() => {
            setCustomTimeIntervalOpen(false);
          }}
          startdt={startdt}
          enddt={enddt}
          didIntervalValueChange={(ele) => {
            dispatch(
              getChangeShowsTemporalIntervalAction("6", ele.startdt, ele.enddt)
            );
          }}
        >
          <Dropdown
            autoAdjustOverflow={false}
            menu={{ items: dateRangeItems, onClick: onDateRangeClick }}
            trigger={["click"]}
            dropdownRender={dropdownRender}
          >
            <KTHomeDesktopFilterButton
              title={dateMessage}
              onClick={(e) => e.preventDefault()}
            />
          </Dropdown>
        </KTSwitchCustomTimeIntervalDropdown>
      </ShowsDtpFilterBarLeftWrapper>
      <ShowsDtpFilterBarRightWrapper>
        <CardLayoutIcon
          className={classNames("layoutModel", {
            activeLayoutModel: layoutMode === LAYOUT_MODE_CARD,
          })}
          onClick={() => onclickChangeLayoutMode(LAYOUT_MODE_CARD)}
        />
        <ListLayoutIcon
          className={classNames("layoutModel", {
            activeLayoutModel: layoutMode === LAYOUT_MODE_LIST,
          })}
          onClick={() => onclickChangeLayoutMode(LAYOUT_MODE_LIST)}
        />
      </ShowsDtpFilterBarRightWrapper>
    </ShowsDtpFilterBarWrapper>
  );
});

export default KTShowsDtpFiterBar;
